import React from 'react'
import { SSOApi } from '../../apis/SSOApi';
import { useRadacadAuth } from '../../Core/useRadacadAuth';
import { SSOEnum } from '../../Core/SSOType';

import { ReactComponent as FacebookIcon } from '../../assets/facebook_icon.svg';

export function FacebookSSORemoveButton(props: {
    onStart?: () => void,
    onSuccess?: () => void,
    onFailure?: (errMsg: string) => void
}) {
    const { onStart, onSuccess, onFailure } = props;
    const { facebookLogin, authState: { accessToken } } = useRadacadAuth();

    const handleOnClick = async (jwtToken: string) => {
        onStart && onStart()
     
        let booleanResponse = await SSOApi.removeSSO(SSOEnum.Facebook, jwtToken);
        if (booleanResponse) {
            const { success, errorMessage } = booleanResponse;
            if (success) {
                onSuccess && onSuccess()
            } else {
                onFailure && onFailure(errorMessage)
            }
        } else {
            onFailure && onFailure("Remove Facebook login failed");
        }
    }
    return facebookLogin && accessToken ? <FacebookIcon
        style={{ cursor: 'pointer', height: "30px", width: "30px" }}
        onClick={() => handleOnClick(accessToken)} /> : <></>
}